if (!customElements.get('hoculus-search-keyword')) {
    class HoculusSearchKeyword extends HTMLElement {
        constructor() {
            super();
            this.searchInput = document.querySelector("store-header input[name='q']");
        }

        connectedCallback() {
            this.addEventListener('click', this.clickHandler.bind(this));
        }

        clickHandler() {
            this.searchInput.value = this.textContent;
            let inputEvent = new Event('input');
            this.searchInput.dispatchEvent(inputEvent);
        }
    }
    customElements.define("hoculus-search-keyword", HoculusSearchKeyword);
}